import React from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';

const REPORTS = [
  { num: 1, title: 'Laporan Pasien', link: '/admin/laporan/pasien', description: 'Ringkasan data pasien dan aktivitas pendaftaran.' },
  { num: 2, title: 'Laporan Rekam Medis', link: '/admin/laporan/rekam-medis', description: 'Rekam medis pasien sebagai dasar pemeriksaan dan diagnosis.' },
  { num: 3, title: 'Laporan Dokter', link: '/admin/laporan/dokter', description: 'Statistik pasien dan kehadiran dokter setiap hari.' },
  { num: 4, title: 'Laporan Pendaftaran', link: '/admin/laporan/pendaftaran', description: 'Analisis status pendaftaran dan antrean.' },
  { num: 5, title: 'Laporan Transaksi', link: '/admin/laporan/transaksi', description: 'Ringkasan pendapatan klinik dan pembayaran pasien.' },
];

export default function AlurAdminKasir() {
  return (
    <AdminLayout title="">
      <div style={{ padding: '4px' }}>
        
        {/* HEADER HALAMAN */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '22px', fontWeight: '800', color: '#111827', margin: 0 }}>
            Laporan Admin
          </h1>
          <p style={{ color: '#6B7280', margin: '6px 0 0', fontSize: '13px', lineHeight: '1.5' }}>
            Halaman ini menampilkan daftar laporan yang tersedia di dashboard admin. 
            Pilih laporan untuk melihat data pasien, rekam medis, dokter, pendaftaran, dan transaksi secara detail.
          </p>
        </div>

        {/* CONTAINER GRID CARDS */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '20px'
        }}>
          {REPORTS.map((report) => (
            <div 
              key={report.num} 
              style={{
                backgroundColor: '#FFFFFF',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              }}
            >
              <div>
                {/* BADGE ANGKA */}
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  backgroundColor: '#EFF6FF',
                  color: '#2563EB',
                  fontWeight: '700',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '14px'
                }}>
                  {report.num}
                </div>

                {/* ISI TEXT */}
                <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#111827', margin: '0 0 8px 0' }}>
                  {report.title}
                </h3>
                <p style={{ fontSize: '13px', color: '#6B7280', margin: '0 0 20px 0', lineHeight: '1.4' }}>
                  {report.description}
                </p>
              </div>

              {/* TOMBOL LINK (FULL WIDTH DI BAWAH) */}
              <Link 
                to={report.link} 
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'center',
                  padding: '10px 16px',
                  backgroundColor: '#2563EB',
                  color: '#FFFFFF',
                  borderRadius: '8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  boxSizing: 'border-box',
                  transition: 'background-color 0.2s'
                }}
              >
                Buka {report.title} →
              </Link>
            </div>
          ))}
        </div>

      </div>
    </AdminLayout>
  );
}